var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "80.31 0.2 25.6 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "so-basketball",
    clipPath: "url(#clip0_695_2015)",
    filter: "url(#filter0_dddddd_695_2015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M93.1125 0.199219C90.5809 0.199219 88.1062 0.949926 86.0012 2.35641C83.8963 3.76289 82.2556 5.76198 81.2868 8.10087C80.318 10.4398 80.0646 13.0134 80.5585 15.4964C81.0523 17.9793 82.2714 20.2601 84.0615 22.0502C85.8517 23.8403 88.1324 25.0594 90.6154 25.5533C93.0983 26.0472 95.672 25.7937 98.0109 24.8249C100.35 23.8561 102.349 22.2155 103.755 20.1105C105.162 18.0056 105.913 15.5308 105.913 12.9992C105.913 11.3183 105.581 9.65384 104.938 8.10087C104.295 6.5479 103.352 5.13684 102.163 3.94825C100.975 2.75966 99.5638 1.81682 98.0109 1.17356C96.4579 0.530301 94.7934 0.199219 93.1125 0.199219Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M103.353 12.9998C103.35 13.4279 103.321 13.8553 103.265 14.2798H99.6551C99.9604 15.7795 100.795 17.1193 102.006 18.0545C101.582 18.7984 101.066 19.4864 100.47 20.1025C98.6121 18.685 97.3855 16.5936 97.0554 14.2798H94.393V23.1514C93.5438 23.2692 92.6823 23.2692 91.833 23.1514V14.2798H89.1706C88.8386 16.5935 87.6102 18.6839 85.7505 20.0999C85.1553 19.4838 84.6393 18.7959 84.2145 18.0519C85.4274 17.1182 86.2638 15.7793 86.571 14.2798H82.9614C82.8436 13.4305 82.8436 12.569 82.9614 11.7198H86.571C86.2662 10.2199 85.4315 8.8799 84.2196 7.94504C84.6444 7.20112 85.1604 6.51313 85.7556 5.89704C87.6143 7.31428 88.841 9.40576 89.1706 11.7198H91.833V2.84808C92.6823 2.73033 93.5438 2.73033 94.393 2.84808V11.7198H97.0554C97.3871 9.40589 98.6156 7.31532 100.476 5.8996C101.071 6.51569 101.587 7.20368 102.012 7.9476C100.798 8.88097 99.9618 10.2201 99.6551 11.7198H103.265C103.321 12.1442 103.35 12.5717 103.353 12.9998Z",
    fill: "#453B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_695_2015",
    x: 0.3125,
    y: 0.199219,
    width: 185.6,
    height: 205.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_695_2015"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.143771 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_695_2015",
    result: "effect2_dropShadow_695_2015"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.119221 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_695_2015",
    result: "effect3_dropShadow_695_2015"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_695_2015",
    result: "effect4_dropShadow_695_2015"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0807786 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_695_2015",
    result: "effect5_dropShadow_695_2015"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0562291 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_695_2015",
    result: "effect6_dropShadow_695_2015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_695_2015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_2015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 25.6,
    fill: "white",
    transform: "translate(80.3125 0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.63adb818bb2ffefdc17b8b07fca0d1c8.svg";
export { ForwardRef as ReactComponent };